import { FiatReplenishGatewayProvider } from '@ppay/definitions'

import { ManualForm } from './forms/ManualForm'
import { InvoiceProps } from './Component'

export const Pay = (props: InvoiceProps) => {
  if (props.invoice.paymentProvider === FiatReplenishGatewayProvider.MANUAL)
    return <ManualForm {...props} />
  return null
}
